import business_front from 'assets/business_card_front.png';
import business_back from 'assets/business_card_back.png';
import sample_card from 'assets/card_sample_01.png';
import sample_logo from 'assets/logo.png';
import og_iamge from 'assets/og_image.png';

import poster_01 from 'assets/poster_01.png';
import poster_02 from 'assets/poster_02.png';
import feels from 'assets/feels.png';

/* -----------------------------
   CATEGORY INFO
----------------------------- */

export const categoryInfo = {
  branding: {
    title: 'portfolioCategory.branding.title',
    desc: 'portfolioCategory.branding.desc',
  },

  web: {
    title: 'portfolioCategory.web.title',
    desc: 'portfolioCategory.web.desc',
  },

  development: {
    title: 'portfolioCategory.development.title',
    desc: 'portfolioCategory.development.desc',
  },

  graphic: {
    title: 'portfolioCategory.graphic.title',
    desc: 'portfolioCategory.graphic.desc',
  },
};

/* -----------------------------
   WORKS
----------------------------- */

export const works = [
  /* -----------------------------
     BRANDING - LOGO
  ----------------------------- */

  // {
  //   id: 'logo',

  //   category: 'branding',

  //   service: 'portfolioService.logo',

  //   type: 'logo',

  //   projects: [
  //     {
  //       id: 'logo-tech-startup',

  //       title: 'portfolioProject.logoStartup.title',
  //       desc: 'portfolioProject.logoStartup.desc',

  //       overview: 'portfolioProject.logoStartup.overview',

  //       direction: 'portfolioProject.logoStartup.direction',

  //       result: 'portfolioProject.logoStartup.result',

  //       img: sample_logo,

  //       year: '2025',

  //       client: 'Tech Startup',

  //       images: [sample_logo, sample_logo],
  //     },

  //     {
  //       id: 'logo-cafe-brand',

  //       title: 'portfolioProject.logoCafe.title',

  //       desc: 'portfolioProject.logoCafe.desc',

  //       overview: 'portfolioProject.logoCafe.overview',

  //       direction: 'portfolioProject.logoCafe.direction',

  //       result: 'portfolioProject.logoCafe.result',

  //       img: sample_logo,

  //       year: '2025',

  //       client: 'Local Cafe',

  //       images: [sample_logo],
  //     },
  //   ],
  // },

  /* -----------------------------
     BRANDING - BUSINESS CARD
  ----------------------------- */

  {
    id: 'businessCard',

    category: 'branding',

    service: 'portfolioService.businessCard',

    type: 'card',

    projects: [
      {
        id: 'business-card-tomadodesign',

        title: 'portfolioProject.businessCardTomado.title',

        desc: 'portfolioProject.businessCardTomado.desc',

        overview: 'portfolioProject.businessCardTomado.overview',

        direction: 'portfolioProject.businessCardTomado.direction',

        result: 'portfolioProject.businessCardTomado.result',

        img: og_iamge,

        year: '2026',

        client: 'Tomado Design',

        cards: [
          {
            front: business_front,
            back: business_back,
          },
        ],
      },
    ],
  },

  /* -----------------------------
     WEB DESIGN
  ----------------------------- */

  {
    id: 'website',

    category: 'web',

    service: 'portfolioService.website',

    type: 'website',

    projects: [
      {
        id: 'corporate-website',

        title: 'portfolioProject.corporateWebsite.title',

        desc: 'portfolioProject.corporateWebsite.desc',

        overview: 'portfolioProject.corporateWebsite.overview',

        direction: 'portfolioProject.corporateWebsite.direction',

        result: 'portfolioProject.corporateWebsite.result',

        img: og_iamge,

        year: '2025',

        client: 'Tomado Design',

        url: 'https://tomadodesign.kr',

        images: ['/images/web-01.png', '/images/web-02.png'],
      },
    ],
  },

  /* -----------------------------
     DEVELOPMENT
  ----------------------------- */

  {
    id: 'publishing',

    category: 'development',

    service: 'portfolioService.publishing',

    type: 'development',

    projects: [
      {
        id: 'responsive-publishing',

        title: 'portfolioProject.publishing.title',

        desc: 'portfolioProject.publishing.desc',

        overview: 'portfolioProject.publishing.overview',

        direction: 'portfolioProject.publishing.direction',

        result: 'portfolioProject.publishing.result',

        img: feels,

        year: '2025',

        client: 'Startup',
        url: 'https://feels-866cf.firebaseapp.com/',

        images: [
          'https://images.unsplash.com/photo-1498050108023-c5249f4df085',
        ],
      },
    ],
  },
  {
    id: 'poster',

    category: 'graphic',

    service: 'portfolioService.poster',

    type: 'poster',

    projects: [
      {
        id: 'restaurant-poster',

        title: 'portfolioProject.restaurantPoster.title',

        desc: 'portfolioProject.restaurantPoster.desc',

        overview: 'portfolioProject.restaurantPoster.overview',

        direction: 'portfolioProject.restaurantPoster.direction',

        result: 'portfolioProject.restaurantPoster.result',

        img: poster_01,

        year: '2026',

        client: '바나나우유',

        images: [poster_01],
      },

      {
        id: 'event-poster',

        title: 'portfolioProject.eventPoster.title',

        desc: 'portfolioProject.eventPoster.desc',

        overview: 'portfolioProject.eventPoster.overview',

        direction: 'portfolioProject.eventPoster.direction',

        result: 'portfolioProject.eventPoster.result',

        img: poster_02,

        year: '2026',

        client: 'Sweet Times',

        images: [poster_02],
      },
    ],
  },
];
